import(/* webpackMode: "eager" */ "/app/app/customer/login/page.tsx");
